import 'slick-carousel/slick/slick.js'

$(document).ready(function () {
  circleAtts()
  circlePosition()

  $('.circle_grafik .item[data-slide]').click(function (e) {
    e.preventDefault()
    var slideno = $(this).data('slide')
    $('.circle_internal_slider').slick('slickGoTo', slideno)
  })

  $('.dhsv_vc_round_slider').on('beforeChange', function (
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    const $item = $('.circle_grafik .item[data-slide="' + nextSlide + '"]')
    const $items = $('.circle_grafik .item')

    $item.addClass('active')
    $items.removeClass('active lined')
    $item.addClass('active')
    $item.prevAll().addClass('lined')

    //SVG circle animate
    var currentVal = parseInt($item.data('slide'))
    var val = (100 / $items.length) * currentVal
    var $circle = $('#svg #bar')
    var r = $circle.attr('r')
    var c = Math.PI * (r * 2)

    var pct = ((100 - val) / 100) * c

    $circle.css({ strokeDashoffset: pct })
  })
})

//Wenn alle Inhalte geladen sind
$(window).load(function () {
  $('.round_slider__images').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
    dots: false,
    arrows: true,
    speed: 300,
    autoplay: false,
    draggable: false,
    asNavFor: '.circle_internal_slider',
  })

  $('.circle_internal_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    dots: false,
    arrows: false,
    speed: 300,
    autoplay: false,
    draggable: false,
    asNavFor: '.round_slider__images',
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 785,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  })
})

//Wenn die Viewport-GrГ¶Гџe verГ¤ndert wird
$(window).resize(function () {
  circleAtts()
  circlePosition()
  triggerActive()
})

//Wenn die Seite gescrollt wird
$(window).scroll(function () {})

function circlePosition() {
  $('.circle_grafik').each(function () {
    var $el = $(this),
      elW = $el.width(),
      $items = $el.find('.item'),
      itemCount = $items.length

    $items.css({
      'transform-origin': elW / 2,
    })

    var i = 0,
      steps = 360 / itemCount

    $items.each(function () {
      $(this).css({
        transform: 'translate(0,-50%) rotate(' + steps * i + 'deg)',
      })
      $(this)
        .find('span')
        .css({
          transform: 'rotate(-' + (steps * i + 90) + 'deg)',
        })
      $(this).on('click', function () {
        $items.removeClass('active lined')
        $(this).addClass('active')
        $(this).prevAll().addClass('lined')

        //SVG circle animate
        var currentVal = parseInt($(this).data('slide'))
        var val = (100 / $items.length) * currentVal
        var $circle = $('#svg #bar')
        var r = $circle.attr('r')
        var c = Math.PI * (r * 2)

        var pct = ((100 - val) / 100) * c

        $circle.css({ strokeDashoffset: pct })
      })
      i++
    })
  })
}

function circleAtts() {
  var r, cx, cy
  if ($(window).width() > 767) {
    r = 225
    cx = 235
    cy = 235
  } else {
    r = 120
    cx = 130
    cy = 130
  }
  var stroke = 2 * Math.PI * r

  $('#svg #bar')
    .attr('r', r)
    .attr('cx', cx)
    .attr('cy', cy)
    .attr('stroke-dasharray', stroke)
}

function triggerActive() {
  var breakpoint = 767,
    isLeft
  if ($(window).width() < breakpoint) {
    isLeft = true
  } else {
    isLeft = false
  }

  if ($(window).width() > breakpoint && !isLeft) {
    $('.item.active').trigger('click')
  } else if ($(window).width() <= breakpoint && isLeft) {
    $('.item.active').trigger('click')
  }
}
